import { createApi } from '@reduxjs/toolkit/query/react';
import DemoExample from 'models/DemoExample';
import { axiosBaseQuery } from 'services/api';

export const demoExamplesApi = createApi({
  reducerPath: 'demoExamplesApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/project-examples/',
  }),
  endpoints: builder => ({
    listDemoExamples: builder.query({
      query: query => ({ params: query }),
      transformResponse: response => {
        if (Array.isArray(response?.results)) {
          return response.results.map(item => new DemoExample(item));
        }
        if (Array.isArray(response)) {
          return response.map(item => new DemoExample(item));
        }
        return [];
      },
    }),
  }),
});

export const { useListDemoExamplesQuery } = demoExamplesApi;
